<div mat-dialog-content [formGroup]="form" [patchFormGroupValues]="config()">
  <bo-widget-base-filter
    formControlName="filter"
    [showEnergySource]="false"
  ></bo-widget-base-filter>
</div>
